const urlStatusMap = {
  'default': {
    '1': '开启',
    '2': '关闭'
  },
  '/experiment/examine/list': {
    '1': '未开始',
    '2': '进行中',
    '3': '已结束'
  },
  '/experiment/practice/list': {
    '1': '完成',
    '2': '未完成'
  },
  '/student/experiment/practice/list': {
    '1': '完成',
    '2': '未完成'
  },
  '/student/examine/list': {
    '1': '未开始',
    '2': '进行中',
    '3': '已结束'
  }
}
export function nameMap(arr, type = 'default') {
  arr.forEach(item => {
    if (item.updatedAt === '') item.updatedAt = '-'
    if (item.targetUrl === '') item.targetUrl = '-'
    if (item.trainingRoomName === '') item.trainingRoomName = '--'
    item.recommendName = item.recommend ? '推荐' : '未推荐'
    item.statusName = urlStatusMap[type] === undefined ? urlStatusMap['default'][String(item.status)] : urlStatusMap[type][String(item.status)]
    for (let key in item) {
      if (item[key] === null || item[key] === undefined || item[key] === '') {
        item[key] = '--'
      }
    }
  })
  return arr
}
